import log from './util/log';
import store from './util/store';
import feed from './feed';
import {closeModal} from './modal'

import extend from 'lodash/extend'

// TODO use jquery free pjax packet
import 'jquery-pjax'


let _pagesDataMap = {},
    initLoaderBar = function() {

      const loaderBar = document.getElementById("js-pjax-loader-bar");
      const progressPanel = loaderBar.firstElementChild;

      let progressPanelTransition = null;
      let localPercent            = 0;
      let timeoutId               = null;

      if (loaderBar) {

        if (progressPanel instanceof HTMLElement) {

          $(document).on("pjax:start", function(ev, xhr, options) {
            // log.info("pjax:start");
            if (xhr !== null) { // только если есть xhr запрос
              progressPercent(0),
                loaderBar.classList.add("is-loading"),
                timeoutId = setTimeout(processProgress, 0)
            }
          });
            $(document).on("pjax:end", function() {
              // log.info("pjax:end");
              timeoutId && clearTimeout(timeoutId),
                progressPercent(100),
                loaderBar.classList.remove("is-loading")
            })
            $(document).on("pjax:timeout", function(e) {
              e.preventDefault()
            })
        }
      }

      function progressPercent(percent) {
        if (percent === 0) {
          if (progressPanelTransition === null) {
            progressPanelTransition = getComputedStyle(progressPanel).transition;
          }
          progressPanel.style.transition = "none";
        }
        localPercent              = percent;
        progressPanel.style.width = localPercent + "%";

        0 === percent && (progressPanel.clientWidth,
          progressPanel.style.transition = progressPanelTransition || "")
      }

      function processProgress() {
        0 === localPercent && (localPercent = 12),
          progressPercent(Math.min(localPercent + 3, 95)),
          timeoutId = setTimeout(processProgress, 500)
      }

      // after back or load from server
      $(document).on("pjax:end", function(ev, xhr, options) {

        // запроса не было, значит это popstate и success не будет - выполняем здесь
        if (xhr === null) {
          // log.print('__pjax__', 'checkCurrentPage called from end');
          feed.checkCurrentPage();
        }

        // перешли на статью
        if (!feed.pageWithFeed()) {
          // log.info("setScrollTop: 0");
          $(window).scrollTop(0);
        }

      });

      $(document).on("pjax:beforeReplace", function(ev, contents, options) {

        if (_pagesDataMap[window.location.href] !== undefined && _pagesDataMap[window.location.href].bodyClasses !== undefined) {
          $('body').prop('class', _pagesDataMap[window.location.href].bodyClasses);
        }

        closeModal();

        // log.info("pjax:beforeReplace", ev, contents, options);
        // log.info(contents)
        // log.info(contents.data("body-classes"));

      });

      $(document).on('pjax:beforeSend', function(event, xhr) {
        var $el = $(event.relatedTarget), $pContainer = $el.closest('[data-pagination-key]'),
            paginationKey                             = $pContainer.data('pagination-key');
        if (paginationKey) {
          xhr.setRequestHeader('X-Pagination-Key', paginationKey);
        }
      });
      // TODO - хранить только основную часть адреса, чтобы не плодить целую кучу для разных статей
      $(document).on("pjax:success", function(e, data, status, xhr, options) {
        var bodyClasses = xhr.getResponseHeader('X-PJAX-BODY-CLASS');
        if (_pagesDataMap[window.location.href] === undefined) {
          _pagesDataMap[window.location.href] = {};
        }
        _pagesDataMap[window.location.href].bodyClasses = bodyClasses;
        store.set("_pages_cache", _pagesDataMap);
        $('body').prop('class', bodyClasses);

        // log.print('__pjax__', 'checkCurrentPage called from success');
        feed.checkCurrentPage();

      });

    };

initLoaderBar();

// disable pjax - для статей надо класс у тега body менять, чтобы была корреткная верстка
// $(document).pjax('a.article-cover', '#app-container');

// $(document).pjax('a.article-cover, a[href="/"]', '#app-container');
$.pjax.defaults.scrollTo = false;

extend(_pagesDataMap, store.get("_pages_cache") || {});
_pagesDataMap[window.location.href] = {
  bodyClasses: $('body').prop('class')
};
store.set("_pages_cache", _pagesDataMap);


// TODO использовать pjax без jquery от github